/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Stamps_Work_TitleInputs */

const en_how_stamps_work_title = /** @type {(inputs: How_Stamps_Work_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do stamps work?`)
};

const ar_how_stamps_work_title = /** @type {(inputs: How_Stamps_Work_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كيف تعمل الطوابع؟`)
};

const de_how_stamps_work_title = /** @type {(inputs: How_Stamps_Work_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie funktionieren Stempel?`)
};

const es_how_stamps_work_title = /** @type {(inputs: How_Stamps_Work_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo funcionan los sellos?`)
};

const fr_how_stamps_work_title = /** @type {(inputs: How_Stamps_Work_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment fonctionnent les timbres ?`)
};

const it_how_stamps_work_title = /** @type {(inputs: How_Stamps_Work_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come funzionano i timbri?`)
};

const ja_how_stamps_work_title = /** @type {(inputs: How_Stamps_Work_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタンプの仕組みは？`)
};

const ko_how_stamps_work_title = /** @type {(inputs: How_Stamps_Work_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스탬프는 어떻게 작동하나요?`)
};

const pt_br_how_stamps_work_title = /** @type {(inputs: How_Stamps_Work_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como os selos funcionam?`)
};

const ru_how_stamps_work_title = /** @type {(inputs: How_Stamps_Work_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Как работают штампы?`)
};

const th_how_stamps_work_title = /** @type {(inputs: How_Stamps_Work_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แสตมป์ทำงานอย่างไร?`)
};

const tr_how_stamps_work_title = /** @type {(inputs: How_Stamps_Work_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pullar nasıl çalışır?`)
};

const zh_cn_how_stamps_work_title = /** @type {(inputs: How_Stamps_Work_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如何获得印花？`)
};

const zh_tw_how_stamps_work_title = /** @type {(inputs: How_Stamps_Work_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如何獲得印花？`)
};

/**
* | output |
* | --- |
* | "How do stamps work?" |
*
* @param {How_Stamps_Work_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const how_stamps_work_title = /** @type {((inputs?: How_Stamps_Work_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Stamps_Work_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_how_stamps_work_title(inputs)
	if (locale === "ar") return ar_how_stamps_work_title(inputs)
	if (locale === "de") return de_how_stamps_work_title(inputs)
	if (locale === "es") return es_how_stamps_work_title(inputs)
	if (locale === "fr") return fr_how_stamps_work_title(inputs)
	if (locale === "it") return it_how_stamps_work_title(inputs)
	if (locale === "ja") return ja_how_stamps_work_title(inputs)
	if (locale === "ko") return ko_how_stamps_work_title(inputs)
	if (locale === "pt_br") return pt_br_how_stamps_work_title(inputs)
	if (locale === "ru") return ru_how_stamps_work_title(inputs)
	if (locale === "th") return th_how_stamps_work_title(inputs)
	if (locale === "tr") return tr_how_stamps_work_title(inputs)
	if (locale === "zh_cn") return zh_cn_how_stamps_work_title(inputs)
	return zh_tw_how_stamps_work_title(inputs)
});